<template>
  <div class="chart-list">
    <div class="grid-item">
      <div class="grid-item-header">Brands</div>
      <ul class="brand-list">
        <li
          v-for="item in brandsList"
          :key="item.id">
          {{ item.brand }}
        </li>
      </ul>
    </div>
    <div
      v-for="item in charts"
      class="grid-item"
      :key="item.id">
      <div class="grid-item-header">{{ item.label }}</div>
      <div v-if="series[item.id].empty" class="empty-chart">
        <svgicon class="empty-chart-icon" name="Warning" />
        <div class="empty-chart-label">{{ series[item.id].label }}</div>
        <el-button
          class="empty-chart-button"
          @click="series[item.id].action()">
          Open settings
        </el-button>
      </div>
      <apexchart
        v-else
        class="chart-container"
        type="bar"
        :height="heightBarChart"
        :options="options"
        :series="series[item.id]" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartList",
  props: {
    brandsList: {
      type: Array,
      required: true,
    },
    series: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      charts: [
        { id: 'exposureS', label: 'Exposure, s' },
        { id: 'bis', label: 'BIS' },
        { id: 'brand_value', label: 'Brand value '}
      ],
      options: {
        chart: {
          parentHeightOffset: 0,
          toolbar: {
            show: false
          },
          tooltip: {
            x: {
              show: true
            }
          },
          zoom: {
            enabled: false
          },
        },
        colors: ['rgba(0, 32, 77, 0.2)'],
        dataLabels: {
          enabled: true,
          formatter: (_, opts) => opts.w.config.series[0].data[opts.dataPointIndex],
          offsetX: 30,
          style: {
            fontSize: '10px',
            colors: ['#00204D']
          },
          textAnchor: 'start',
        },
        grid: {
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: false
            },
          },
        },
        plotOptions: {
          bar: {
            barHeight: '70%',
            borderRadius: 6,
            dataLabels: {
              position: 'top',
            },
            horizontal: true,
          }
        },
        stroke: {
          colors: ['transparent'],
          width: 5,
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
          categories: [''],
          labels: {
            formatter: value => {
              if (value > 0 && value < 0.5) {
                return value.toFixed(2);
              }
              return value % 1 != 0 ? value.toFixed(1) : value;
            },
            style: {
              colors: 'rgba(0, 32, 77, 0.5)',
              fontSize: '10px'
            }
          },
          show: false,
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          max: value => {
            const newMaxValue = value * 1.3;
            if (value < 1) {
              return newMaxValue
            }
            if (value < 10) {
              return Math.ceil(newMaxValue)
            }
            const rounding = Math.round(value).toString().split('').slice(0, -1).reduce(res => res * 10, 1);
            return Math.round(newMaxValue / rounding) * rounding;
          },
          tooltip: {
            enabled: false,
          },
        }
      },
    }
  },
  computed: {
    heightBarChart() {
      const itemHeight = 40;
      return Math.max(250, this.brandsList.length * itemHeight);
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-list {
  display: flex;
  gap: 35px;
  padding: 20px;
}

.grid-item {
  display: flex;
  flex-direction: column;

  &:not(:first-child) {
    flex: 1;
  }
}

.grid-item-header {
  padding-bottom: 9px;
  border-bottom: 2px solid var(--primary);
  font-family: "AcronisCyberBold";
  text-transform: uppercase;
}

.brand-list {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
  margin: 0;
  padding: 5px 0 35px;
  font-size: 14px;
  list-style-type: none;
  text-transform: uppercase;
}

.chart-container {
  margin-top: -20px;
  margin-left: -25px;
}

.empty-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 20px auto 0;
  padding: 20px 40px;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 6px;
}

.empty-chart-icon {
  width: 32px;
  fill: #FF9800;
}

.empty-chart-label {
  margin: 16px auto 24px;
  line-height: 121%;
}

.empty-chart-button {
  padding: 8px 40px;
  border-radius: 6px;
  font-weight: 700;
}
</style>
